// extracted by mini-css-extract-plugin
module.exports = {"root":"Teacher_root__ymMhg","name":"Teacher_name__3qkYs","phone":"Teacher_phone__1WuGP","content":"Teacher_content__2-FgG"};